// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"pageNotFound_notFoundContainer__skhHk","notFoundCode":"pageNotFound_notFoundCode__FLTFr","notFoundText":"pageNotFound_notFoundText__shImy"};